// Authentication service
// manages the authentication state and persistence
// as well as methods for interacting with the backend api

// URL and endpoint constants
let LOGIN_URL = '/auth/login/'

import http from '../http'
import { store, reset } from '../../store'

var auth = {
  authenticated: false,
  login (credentials) {
    let payload = {
      email: credentials.email,
      password: credentials.password
    }
    let headers = {
      'x-consumer-id': credentials.clientId
    }
    if (credentials.clientId === 'digiteka') {
      LOGIN_URL = '/auth/digiteka-login/'
    }
    return new Promise((resolve, reject) => {
      http.post(LOGIN_URL, headers, payload).then((response) => {
        localStorage.setItem('auth_token', response.key)
        localStorage.setItem('client_id', credentials.clientId)
        this.authenticated = true
        store.commit('SET_AUTHENTICATED', true)
        resolve()
      }, (error) => {
        reject(error)
      })
    })
  },
  logout () {
    localStorage.removeItem('auth_token')
    // localStorage.removeItem('client_id')
    this.authenticated = false
    reset(store)
  },
  checkAuth () {
    let token = localStorage.getItem('auth_token')
    let clientId = localStorage.getItem('client_id')
    if (token && clientId) {
      this.authenticated = true
    } else {
      this.authenticated = false
    }
    store.commit('SET_AUTHENTICATED', this.authenticated)
  },
  getAuthHeader () {
    return {
      'Authorization': 'Token ' + localStorage.getItem('auth_token'),
      'x-consumer-id': localStorage.getItem('client_id')
    }
  }
}

export default auth
